/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyDocumentType = {
  type: 'Enum',
} as const;
